import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { useNonprofitSocialMediaLogic } from './hooks/useNonprofitSocialMediaLogic';
import { NonprofitSocialMediaForm } from './NonprofitSocialMediaForm';

export const EddNonprofitSocialMedia = () => {
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useNonprofitSocialMediaLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        content={t('organic.NonProfitSocialMedia.title')}
        headingContainerCustomStyle='!mb-[24px]'>
        <NonprofitSocialMediaForm />
      </StepPageWrapper>
    </FormProvider>
  );
};
